import React, { Component } from "react";
import { LongDateFormat } from "../../constants/DateFormatters";

class NotificationItem extends Component {
  state = {
    DeleteMode: false
  };
  handleDelete = () => {
    this.setState({
      DeleteMode: !this.state.DeleteMode
    });
  };
  render() {
    const { _ } = this.props;
    return (
      <div
        className={
          "notifications-list-item" +
          (this.props.Notification.new ? " new" : "") +
          (this.state.DeleteMode ? " delete" : "")
        }
      >
        {this.state.DeleteMode ? (
          <div className="del">
            <p>Delete this notification?</p>
            <div className="del-action">
              <button
                className="btn"
                onClick={() =>
                  this.props.DeleteNotificationsById([
                    this.props.Notification.id
                  ])
                }
              >
                <i className="icon-omni-tick-circle" />
              </button>
              <button className="btn" onClick={this.handleDelete}>
                <i className="icon-omni-close-circle" />
              </button>
            </div>
          </div>
        ) : (
          <>
            <strong>{this.props.Notification.message}</strong>
            <span>
              {LongDateFormat(
                this.props.Notification.createdDateTime,
                _.MomentLang
              )}
            </span>
            <button className="btn" onClick={this.handleDelete}>
              <i className="icon-omni-delete" />
            </button>
          </>
        )}
      </div>
    );
  }
}

export default NotificationItem;
